<template>
  <v-dialog v-model="dialog" width="1100" scrollable>
    <v-card>

      <!-- Hero immagine -->
      <div style="position:relative; height:220px; cursor:pointer" @click="$refs.input.click()">
        <v-img
          :src="info_img_src"
          height="220"
          gradient="to bottom, rgba(0,0,0,.05), rgba(0,0,0,.6)"
          @load="() => console.log('[hero] immagine caricata:', info_img_src)"
          @error="() => console.error('[hero] errore caricamento:', info_img_src)"
        >
          <template v-slot:placeholder>
            <div class="d-flex flex-column align-center justify-center grey lighten-3 fill-height">
              <v-icon x-large color="grey lighten-1">mdi-image-plus-outline</v-icon>
              <span class="text-caption grey--text mt-2">Aggiungi immagine di copertina</span>
              <div class="mt-3 text-subtitle-1 grey--text text--darken-2 font-weight-medium">{{ specie.nome }}</div>
            </div>
          </template>
          <div class="d-flex align-end fill-height pa-4">
            <div class="flex-grow-1">
              <div class="white--text text-h5 font-weight-medium">{{ specie.nome }}</div>
              <div class="white--text text-caption font-italic">{{ specie.nome_sc }}</div>
            </div>
            <v-btn icon color="white"><v-icon>mdi-camera</v-icon></v-btn>
          </div>
        </v-img>
        <input
          type="file"
          style="display: none"
          @change="onFileChange($event)"
          ref="input"
        />
      </div>

      <!-- Tab navigation -->
      <v-tabs v-model="tab" color="green" background-color="transparent">
        <v-tab><v-icon left small>mdi-text</v-icon>Generali</v-tab>
        <v-tab><v-icon left small>mdi-sprout</v-icon>Cura</v-tab>
        <v-tab>
          <v-icon left small>mdi-flower</v-icon>
          Serie
          <v-chip x-small class="ml-1" v-if="specie.series.length">{{ specie.series.length }}</v-chip>
        </v-tab>
      </v-tabs>
      <v-divider />

      <v-card-text style="height: 520px">
        <v-tabs-items v-model="tab">

          <!-- Tab Generali -->
          <v-tab-item>
            <v-row class="mt-2">
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_generali"
                  rows="7"
                  label="Informazioni generali"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_curiosita"
                  rows="4"
                  label="Curiosità"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_esperti"
                  rows="4"
                  label="Per Esperti"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Tab Cura -->
          <v-tab-item>
            <v-row class="mt-2">
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_rinvaso"
                  rows="4"
                  label="Rinvaso"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_esposizione"
                  rows="4"
                  label="Esposizione"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_irrigazione"
                  rows="4"
                  label="Irrigazione"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_manutenzione"
                  rows="4"
                  label="Manutenzione"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="fields.info_malattie"
                  rows="4"
                  label="Malattie"
                  outlined
                  hide-details
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Tab Serie -->
          <v-tab-item>
            <template v-if="specie.series.length">
              <v-expansion-panels flat accordion multiple class="mt-2">
                <v-expansion-panel
                  v-for="serie in specie.series"
                  :key="serie.id"
                >
                  <v-expansion-panel-header>
                    <span class="green--text font-weight-medium">{{ serie.nome }}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <InfoSerie v-if="dialog" :serie="serie" :id_specie="specie.id" />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>
            <v-row v-else class="mt-6 justify-center">
              <span class="grey--text">Nessuna serie per questa specie</span>
            </v-row>
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <InfoPreview :id_specie="id_specie" :all_info="all_info" />
        <v-btn
          color="green"
          text
          :disabled="!dirty || saving"
          :loading="saving"
          @click="salva()"
        >Salva</v-btn>
        <v-btn text color="grey" @click="close()">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InfoPreview from "./info_preview.vue";
import InfoSerie from "./informazioni_serie.vue";

const CAMPI = [
  "info_generali",
  "info_rinvaso",
  "info_esposizione",
  "info_irrigazione",
  "info_manutenzione",
  "info_malattie",
  "info_curiosita",
  "info_esperti",
];

export default {
  components: { InfoPreview, InfoSerie },
  props: {
    id_specie: String,
  },
  data() {
    return {
      dialog: false,
      tab: 0,
      fields: Object.fromEntries(CAMPI.map((c) => [c, ""])),
      original_fields: Object.fromEntries(CAMPI.map((c) => [c, ""])),
      all_info: null,
      file: null,
      md5: null,
      cache_buster: null,
      saving: false,
    };
  },
  computed: {
    specie() {
      return this.$store.getters.get_specie_by_id(this.id_specie);
    },
    info_img_src() {
      const base = `${process.env.VUE_APP_API_ROOT}/specie/${this.id_specie}/info_img`;
      const url = this.cache_buster ? `${base}?md5=${this.cache_buster}` : base;
      console.log("[informazioni_specie] info_img_src:", url);
      return url;
    },
    dirty() {
      return CAMPI.some((c) => this.fields[c] !== this.original_fields[c]);
    },
  },
  methods: {
    open() {
      this.$store
        .dispatch("fetch_info_specie_by_id", { id_specie: this.id_specie })
        .then((res) => {
          this.all_info = res;
          CAMPI.forEach((c) => {
            this.fields[c] = res[c] || "";
            this.original_fields[c] = res[c] || "";
          });
          this.md5 = res.info_img_md5;
          this.cache_buster = res.info_img_md5;
          this.tab = 0;
          this.dialog = true;
        });
    },
    openWithPreload(campi) {
      this.$store
        .dispatch("fetch_info_specie_by_id", { id_specie: this.id_specie })
        .then((res) => {
          this.all_info = res;
          CAMPI.forEach((c) => {
            this.original_fields[c] = res[c] || "";
            this.fields[c] = Object.prototype.hasOwnProperty.call(campi, c)
              ? campi[c]
              : res[c] || "";
          });
          this.md5 = res.info_img_md5;
          this.cache_buster = res.info_img_md5;
          this.tab = 0;
          this.dialog = true;
        });
    },
    close() {
      this.dialog = false;
    },
    async salva() {
      this.saving = true;
      const cambiati = CAMPI.filter((c) => this.fields[c] !== this.original_fields[c]);
      await Promise.all(
        cambiati.map((c) =>
          this.$store.dispatch("send_specie_info", {
            id_specie: this.id_specie,
            categoria: c,
            text: this.fields[c],
          })
        )
      );
      CAMPI.forEach((c) => { this.original_fields[c] = this.fields[c]; });
      this.saving = false;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      console.log("[hero] upload file:", file?.name);
      const formData = new FormData();
      formData.append("file", file);
      this.$store
        .dispatch("send_specie_info_img", { id_specie: this.id_specie, formData })
        .then((res) => {
          console.log("[hero] risposta server:", res.data);
          this.md5 = res.data.md5;
          this.cache_buster = Date.now();
          console.log("[hero] md5 aggiornato:", this.md5, "cache_buster:", this.cache_buster);
        });
    },
  },
};
</script>
